import { Reveal } from "./motion";
import { IMG } from "./data";

const CAPTIONS = ["Produktionshalle", "Bürowelten", "Objektbetreuung", "Anlagenreinigung"];

export default function Gallery() {
  return (
    <section id="referenzen" className="relative bg-[#111214] py-24 lg:py-36">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="mb-16 flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <div className="mb-5 flex items-center gap-4">
              <span className="h-px w-12 bg-[#4fd1c5]" />
              <span className="font-mono-spc text-[11px] uppercase tracking-[0.35em] text-[#4fd1c5]">Einblicke</span>
            </div>
            <Reveal>
              <h2 className="font-head text-4xl font-light uppercase tracking-tighter text-metal sm:text-5xl lg:text-6xl">
                Wo wir arbeiten
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
          {IMG.gallery.map((src, i) => (
            <Reveal
              key={i}
              delay={i * 0.08}
              className={i % 3 === 0 ? "col-span-2 lg:col-span-2" : "col-span-1"}
            >
              <figure className="group relative aspect-[4/5] overflow-hidden rounded-sm border border-white/5">
                <img
                  src={src}
                  alt={CAPTIONS[i]}
                  className="h-full w-full object-cover grayscale transition-[filter,transform] duration-[900ms] ease-out group-hover:grayscale-0 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0f]/80 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                <figcaption className="absolute bottom-5 left-5 translate-y-3 font-mono-spc text-[11px] uppercase tracking-[0.25em] text-white opacity-0 transition-[opacity,transform] duration-500 group-hover:translate-y-0 group-hover:opacity-100">
                  {CAPTIONS[i]}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
